import React from 'react';
import PropTypes from 'prop-types';

import { Tag } from './styles';

/**
 * Typo
 * A typographic element based on the Junto Design system.
 *
 * @param {string} element - The semantic HTML element for the typo
 * @param {string} size - The font token suffix based on Junto's design system
 * @param {string} color - The color token suffix based on Junto's design system
 * @param {array} margin - The spacing token suffix based on Junto's design system
 * @param {string} weight - The weight token based on Junto's design system
 * @param {bool} isLink - Whether would the element be formatted as such
 */
const Typo = ({ element, size, color, weight, margin, children, isLink, ...props }) => {
  return (
    <Tag
      as={element}
      size={size}
      color={color}
      weight={weight}
      margin={margin}
      isLink={isLink}
      {...props}
    >
      {children}
    </Tag>
  );
};

Typo.defaultProps = {
  element: 'p'
};

Typo.propTypes = {
  element: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
  weight: PropTypes.string,
  margin: PropTypes.instanceOf(Array),
  children: PropTypes.node,
  isLink: PropTypes.bool
};

export default Typo;
